import { render, staticRenderFns } from "./consent.vue?vue&type=template&id=4c6492d0&scoped=true&"
import script from "./consent.vue?vue&type=script&lang=ts&"
export * from "./consent.vue?vue&type=script&lang=ts&"
import style0 from "./consent.vue?vue&type=style&index=0&id=4c6492d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6492d0",
  null
  
)

export default component.exports